import React, {useEffect, useState} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {getProfile} from '../utils/api';

const DEFAULT_SUMMARY = "'Simulacre'를 주제로 꾸준한 작품활동을 하고 있으며, 사진을 통한 '빛'에 대한 탐구를 지속하고 있다. '빛은 성당이 되었다'라는 저서를 출간하였으며 현재는 IT에 종사하며 UX전략실의 장을 수행하고 있다.";

function Profile(props) {
    const [on,setOn] = useState(false);
    const [profile, setProfile] = useState({ summary: DEFAULT_SUMMARY, history: [] });
    const location = useLocation();
    const locationNum = location.pathname.split("/");
    useEffect(() => {
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        console.log(props.pageN.conBox)
        //props.pageN.conBox.current.scrollTo({ top: 0, behavior: 'auto' });
        const timeOut = setTimeout(()=> setOn(true), 100);
        return () => clearTimeout(timeOut);
    });

    useEffect(() => {
        getProfile()
            .then(data => setProfile({ summary: data.summary || DEFAULT_SUMMARY, history: data.history || [] }))
            .catch(() => {});
    }, []);
    return (
        <div className={on ? "conBox on" : "conBox"}>
            <div className="topBg"></div>
            <div className="conTopWave">
                <div className="conTopWaveIn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6000" height="240" viewBox="0 0 6000 240" preserveAspectRatio="xMidYMid slice">
                        <pattern id="wave" width=".25" height="1.1" patternContentUnits="objectBoundingBox">
                        <path fill="#1A2C2D" d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"></path>
                        </pattern>
                        <rect width="6000px" height="140"></rect>
                    </svg>
                </div>
            </div>
            <div className="pageNameBox">
                <div className="pageNameBoxIn">
                    <h2>PROFILE</h2>
                    <p>Kang, deokwon</p>
                </div>
            </div>
            
            <div className="profileMovieBox">
                <video loop autoPlay muted playsInline poster={process.env.PUBLIC_URL+"/assets/img/profile/profile.jpg"} preload="auto">
                    <source src={process.env.PUBLIC_URL+"/assets/img/profile/profile.mp4"} type="video/mp4" />
                    <p><img src={process.env.PUBLIC_URL+"/assets/img/profile/profile.jpg"} alt="" /></p>
                </video>
            </div>
            <div className="conInBox">
                <h2><img src="../../name.svg" alt="Kang, deok won" /></h2>
                <p>
                    {profile.summary}
                </p>
                <ul className="conInTextList">
                    {profile.history.map(item => (
                        <li key={item.id}><div>{item.year}</div>
                            <strong>
                                {item.icon && <img src={process.env.PUBLIC_URL+item.icon} className="iconWa" alt="web award" />}
                                {' '}{item.title}
                            </strong>
                            <span>{item.subtitle}</span>
                        </li>
                    ))}
                </ul>
                <div className="manBox">
                    <img src={process.env.PUBLIC_URL+"/assets/img/common/man2.png"} alt="" className="manHead" />
                    <img src={process.env.PUBLIC_URL+"/assets/img/common/man.png"} alt="" className="manBody" />
                </div>
            </div>
        </div>
    );
};

export default Profile;